(()=>{if(window.__mbfProductReviewUi)return;window.__mbfProductReviewUi=true;

const q=(root,sel)=>root.querySelector(sel);
const qa=(root,sel)=>[...root.querySelectorAll(sel)];

function setRating(section,rating){
  const value=Number(rating)||0;
  qa(section,".mbf-product-review-star").forEach(star=>{
    const n=Number(star.dataset.rating);
    star.classList.toggle("is-selected",n<=value);
    star.setAttribute("aria-pressed",String(n===value));
  });
  qa(section,".mbf-native-review-form__star").forEach(star=>{
    const n=Number(star.dataset.mbfFormStar);
    star.classList.toggle("is-selected",n<=value);
    star.setAttribute("aria-pressed",String(n===value));
  });
  const input=q(section,'input[name="rating"]');
  if(input)input.value=value?String(value):"";
}

function openForm(section,rating){
  if(rating)setRating(section,rating);
  const wrap=q(section,"[data-mbf-review-form-wrap]");
  if(!wrap)return;
  wrap.hidden=false;
  setTimeout(()=>wrap.scrollIntoView({behavior:"smooth",block:"center"}),30);
}

function text(el,value){if(el)el.textContent=value??""}

function renderReview(review){
  const article=document.createElement("article");
  article.className="mbf-native-review-card";

  const top=document.createElement("div");
  top.className="mbf-native-review-card__top";
  const stars=document.createElement("span");
  stars.className="mbf-native-review-card__stars";
  const r=Math.max(1,Math.min(5,Number(review.rating)||0));
  stars.textContent="★★★★★".slice(0,r)+"☆☆☆☆☆".slice(0,5-r);
  stars.setAttribute("aria-label",r+" / 5");

  const date=document.createElement("time");
  date.className="mbf-native-review-card__date";
  const d=new Date(review.created_at);
  date.textContent=Number.isNaN(d.getTime())?"":d.toLocaleDateString();
  top.append(stars,date);

  const body=document.createElement("p");
  text(body,review.review_body);
  const name=document.createElement("strong");
  text(name,review.reviewer_name);

  article.append(top,body,name);
  return article;
}

async function loadReviews(section){
  const endpoint=section.dataset.endpoint;
  const handle=section.dataset.productHandle;
  if(!endpoint||!handle)return;
  try{
    const res=await fetch(endpoint+"?product_handle="+encodeURIComponent(handle),{headers:{Accept:"application/json"},cache:"no-store"});
    if(!res.ok)return;
    const data=await res.json();
    if(!data?.ok||!Array.isArray(data.reviews)||!data.reviews.length)return;
    const list=q(section,"[data-mbf-native-review-list]");
    const items=q(section,"[data-mbf-native-review-items]");
    if(!list||!items)return;
    items.replaceChildren(...data.reviews.map(renderReview));
    list.hidden=false;
  }catch{}
}

async function submitReview(section,form){
  const status=q(section,"[data-mbf-review-status]");
  const submit=q(form,'button[type="submit"]');
  const fd=new FormData(form);
  const rating=Number(fd.get("rating")||0);
  const name=String(fd.get("reviewer_name")||"").trim();
  const review=String(fd.get("review_body")||"").trim();
  const email=String(fd.get("reviewer_email")||"").trim();
  const fail=(message)=>{
    if(status){status.className="mbf-native-review-form__status is-error";text(status,message)}
  };
  if(!rating){fail(section.dataset.msgError||"Please choose a rating.");return}
  if(name.length<2||review.length<3){fail(section.dataset.msgError||"Please complete the form.");return}

  if(submit){submit.disabled=true;submit.setAttribute("aria-busy","true")}
  if(status){status.className="mbf-native-review-form__status";text(status,"…")}
  try{
    const res=await fetch(section.dataset.endpoint,{
      method:"POST",
      headers:{"Content-Type":"application/json","Accept":"application/json"},
      body:JSON.stringify({
        product_handle:section.dataset.productHandle,
        product_title:section.dataset.productTitle,
        locale:section.dataset.locale||document.documentElement.lang||"",
        reviewer_name:name,
        reviewer_email:email,
        rating,
        review_body:review,
        website:String(fd.get("website")||"")
      })
    });
    const data=await res.json().catch(()=>({}));
    if(!res.ok||!data?.ok){
      if(res.status===409||data?.error==="ALREADY_REVIEWED")fail(section.dataset.msgDuplicate||section.dataset.msgError);
      else fail(section.dataset.msgError||"Something went wrong.");
      return;
    }
    if(status){status.className="mbf-native-review-form__status is-success";text(status,section.dataset.msgSuccess||"Thank you.")}
    const list=q(section,"[data-mbf-native-review-list]");
    const items=q(section,"[data-mbf-native-review-items]");
    if(list&&items&&data.review){
      items.prepend(renderReview(data.review));
      list.hidden=false;
    }
    form.reset();
    setRating(section,0);
  }catch{
    fail(section.dataset.msgError||"Something went wrong.");
  }finally{
    if(submit){submit.disabled=false;submit.removeAttribute("aria-busy")}
  }
}

document.addEventListener("click",e=>{
  const section=e.target.closest?.("[data-mbf-native-reviews]");
  if(!section)return;

  const topStar=e.target.closest(".mbf-product-review-star");
  if(topStar){e.preventDefault();openForm(section,Number(topStar.dataset.rating)||0);return}

  const open=e.target.closest(".mbf-product-review-open");
  if(open){e.preventDefault();openForm(section,0);return}

  const formStar=e.target.closest(".mbf-native-review-form__star");
  if(formStar){e.preventDefault();setRating(section,Number(formStar.dataset.mbfFormStar)||0)}
});

document.addEventListener("submit",e=>{
  const form=e.target.closest?.("[data-mbf-review-form]");
  if(!form)return;
  e.preventDefault();
  const section=form.closest("[data-mbf-native-reviews]");
  if(section)submitReview(section,form);
});

function init(){
  document.querySelectorAll("[data-mbf-native-reviews]").forEach(section=>{
    loadReviews(section);
    const rating=Number(new URL(window.location.href).searchParams.get("review_rating"));
    if(rating>=1&&rating<=5)setTimeout(()=>openForm(section,rating),220);
  });
}
if(document.readyState==="loading")document.addEventListener("DOMContentLoaded",init,{once:true});else init();
})();